/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
function UserManagement() {
  return <h1>User Mangement Landing Page</h1>;
}
export default UserManagement;
